// packages import
import { Box, Button, TextField } from '@mui/material'
import { FC } from 'react'

// others

interface RecordPaymentFiltersProps {
  matterId: string
  billId: string
  clientId: string
  onMatterIdChange: (value: string) => void
  onBillIdChange: (value: string) => void
  onClientIdChange: (value: string) => void
  onSearch: () => void
  onClear: () => void
  loading: boolean
}

const RecordPaymentFilters: FC<RecordPaymentFiltersProps> = ({
  matterId,
  billId,
  clientId,
  onMatterIdChange,
  onBillIdChange,
  onClientIdChange,
  onSearch,
  onClear,
  loading
}): JSX.Element => {
  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      onSearch()
    }
  }

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" gap={2} flexWrap="wrap" alignItems="flex-end">
        <TextField
          label="Matter ID"
          size="small"
          value={matterId}
          onChange={(e) => onMatterIdChange(e.target.value)}
          placeholder="Enter matter number"
          sx={{ minWidth: 200 }}
          onKeyPress={handleKeyPress}
        />
        <TextField
          label="Bill ID"
          size="small"
          value={billId}
          onChange={(e) => onBillIdChange(e.target.value)}
          placeholder="Enter bill ID"
          sx={{ minWidth: 200 }}
          onKeyPress={handleKeyPress}
        />
        <TextField
          label="Client ID"
          size="small"
          value={clientId}
          onChange={(e) => onClientIdChange(e.target.value)}
          placeholder="Enter client ID"
          sx={{ minWidth: 200 }}
          onKeyPress={handleKeyPress}
        />
        <Button variant="contained" color="primary" onClick={onSearch} disabled={loading || (!matterId && !billId && !clientId)}>
          Search
        </Button>
        <Button variant="outlined" color="primary" onClick={onClear} disabled={loading}>
          Clear
        </Button>
      </Box>
    </Box>
  )
}

export default RecordPaymentFilters
